export interface RegionalManagerDashboardRow {
  locationId: string;
  ownerUserId: string;
  locationTitleName: string;
  futureShiftCounts: number;
  unfilledShiftCounts: number;
  withApplicantsShiftCounts: number;
  pharmacy?: {
    id: string;
    name: string;
    owner?: {
      owner?: {
        firstName?: string;
        lastName?: string;
      };
    };
    approval?: {
      status?: string;
    };
  };
}

export interface RegionalManagerDashboardResponse {
  data?: RegionalManagerDashboardRow[];
  pageInfo?: {
    page: number;
    pages: number;
    total: number;
  };
}

export const getRegionalManagerLocationDisplayLabel = (
  row: RegionalManagerDashboardRow
) => {
  const fullName = getRegionalManagerOwnerDisplayName(row);
  const locationName = row?.pharmacy?.name?.trim() || "";

  if (fullName && locationName) {
    return `${fullName} - ${locationName}`;
  }

  return row.locationTitleName;
};

export const getRegionalManagerOwnerDisplayName = (
  row: RegionalManagerDashboardRow
) => {
  const firstName = row?.pharmacy?.owner?.owner?.firstName?.trim() || "";
  const lastName = row?.pharmacy?.owner?.owner?.lastName?.trim() || "";

  return [firstName, lastName].filter(Boolean).join(" ");
};
